import { NavLink, Link, useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';

import { useAssessmentContext } from '../../providers';

//Images
import { IoCloseSharp } from 'react-icons/io5';
import { ReactComponent as Logo } from '../../images/logo.svg';
import { ReactComponent as LeftArrow } from '../../images/left-arrow.svg';

function AssessmentNav() {
    const navigate = useNavigate();

    const {
        assessmentStep,
        currentQuestionData,
        currentQuestionIndex,
        previousQuestion,
        questions,
    } = useAssessmentContext();

    return (
        <>
            <nav
                className={
                    assessmentStep === 'result'
                        ? 'mb-4 flex justify-center !pb-0 pt-4 lg:pt-16'
                        : 'flex items-end justify-between py-4 pt-8 lg:py-9 lg:pt-16'
                }>
                {assessmentStep === 'questions' && (
                    <button
                        data-attr="previous-question"
                        onClick={() => {
                            let testIndex = currentQuestionIndex;

                            testIndex--;

                            while (questions[testIndex]?.skip) testIndex--;

                            testIndex === -1
                                ? navigate(-1)
                                : previousQuestion(currentQuestionData?.answerKey);
                        }}
                        disabled={currentQuestionIndex === 0}
                        className={`block transition duration-300 ${
                            currentQuestionIndex === 0 ? 'opacity-0' : 'opacity-100'
                        }`}>
                        <LeftArrow data-attr="previous-question pointer-events-none" />
                    </button>
                )}
                <Link to="/" className="mx-auto inline-block">
                    <Logo className="w-11 lg:w-16" />
                </Link>
                {assessmentStep === 'questions' && (
                    <NavLink
                        data-attr="assessment-exit"
                        to="/"
                        className="group flex items-center font-heading leading-none tracking-widest text-offwhite">
                        <span
                            className="translate-y-[1px] opacity-50 transition group-hover:-translate-x-2 group-hover:opacity-100"
                            data-attr="assessment-exit">
                            exit
                        </span>
                        <IoCloseSharp className="text-3xl" data-attr="assessment-exit" />
                    </NavLink>
                )}
            </nav>
            <motion.div
                className={`mb-8 sm:mb-16 h-0.5 w-full bg-purple-medium ${
                    assessmentStep === 'questions' ? 'block' : 'hidden'
                }`}>
                <div
                    className="h-0.5 bg-green-400 transition-all"
                    style={{
                        width:
                            Math.ceil((100 * (currentQuestionIndex + 1)) / questions.length) + '%',
                    }}></div>
            </motion.div>
        </>
    );
}

export default AssessmentNav;
